// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fqHd","colMin":"styles_colMin__29lfQ"};